import { ConfigurableQuestionnaireKey, questionnaireTypes } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import { ApplicationState } from "../applicationState";
import { ADMIN_ROLES } from "../auth";

const editRoute = {
    "/edit": {
        title: "Edit"
    }
};

const childRoutes = {
    "/:questionnaireType": {
        title: (state: ApplicationState) => questionnaireTypes[state.router.params.questionnaireType as ConfigurableQuestionnaireKey].displayName,
        ...editRoute,
        "/create": {
            title: "Create"
        }
    }
};

export const routes = {
    "/questionnaireConfig": {
        title: "Form Customisation",
        authorize: [ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
        ...childRoutes
    }
};
